import React from 'react';

const amenities = [
  { en: 'Breakfast included', am: 'ቁርስ ይጨምራል' },
  { en: 'Free Wi‑Fi in all rooms', am: 'በሁሉም ክፍሎች ነፃ ዋይ‑ፋይ' },
  { en: 'Daily housekeeping', am: 'በየቀኑ የክፍል ንጽህና አገልግሎት' },
  { en: 'In-room tea/coffee facilities', am: 'በክፍል ውስጥ የቲ/ቡና መዘጋጃ መሳሪያዎች' },
  { en: 'Complimentary bottled water', am: 'ነፃ የፍሳሽ ውሃ' },
  { en: 'Flat-screen TV with satellite channels', am: 'ከሳተላይት መስመሮች ጋር የፍላት ስክሪን ቲቪ' }
];

const OtherServices = ({ language }) => (
  <section className="py-5 bg-light" data-aos="fade-up">
    <div className="container">
<h2 className="fw-bold mb-4">
  {language === 'am' ? 'የክፍል መኖሪያ እና አገልግሎቶች' : 'Room Accommodation'}
</h2>
      <div className="row">
        {amenities.map((amenity, index) => (
          <div key={index} className="col-md-6 mb-2">
            <span>✅ {amenity[language]}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default OtherServices;
